export const cacheKey = 'trackers'
export const baseUrl = 'trackers?api-version=3.3'
